import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {WalkOfShame} from "../WalkOfShame";
import {WalkOfShameSymbol} from "../symbol/WalkOfShameSymbol";

export class WalkOfShameFreespinIdlePresentation implements FlowStatePresentation {

    constructor() {
    }

    public async start(flowStateController: FlowStateController): Promise<void> {
        let s2SymId: number,
            fsLeft: number;

        if (WalkOfShame.model.isRestore) {
            s2SymId = WalkOfShame.model.parsedInitData.s2SymId;
            fsLeft = WalkOfShame.model.parsedInitData.freespinsLeft - 1;

            await new Promise<void>(resolve => {
                WalkOfShame.freespinIntro.show(resolve);
            });
            WalkOfShame.keypadPlugin.setZeroBetSpinCounter(fsLeft);
        } else {
            s2SymId = WalkOfShame.model.parsedGameData.s2SymId;
            fsLeft = WalkOfShame.model.parsedGameData.freespinsLeft - 1;

            WalkOfShame.keypadPlugin.setZeroBetSpinCounter(fsLeft);
        }
        WalkOfShame.model.fsLeftCtr = fsLeft;

        if (s2SymId > -1) {
            WalkOfShame.stickyS2.toggleS2(true, s2SymId);
            WalkOfShame.stickyS2.playS2Animation("normal", false).eventCallback("onComplete", () => {
                WalkOfShame.stickyS2.playS2Animation("idle", true);
            });

            const sym: WalkOfShameSymbol = WalkOfShame.reels[0].getSymbol(s2SymId + 1);
            if (sym.symbolName === "S2") {
                sym.visible = false;
            }
        }

        WalkOfShame.apiPlugin.betHandler.zeroBet();
        flowStateController.finish();
    }
}